<template>
    <div class="container">
      <h1>注册成功</h1>
      <p>感谢您的注册！您可以继续使用我们的服务。</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SuccessView',
  };
  </script>
  
  <style scoped>
  .container {
    /* max-width: 400px;
    margin: 0 auto;
    padding: 20px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: center; */
  }
  </style>